import React, { useEffect, useState } from "react"
import { Col, Row, Table, Container } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import Navbar from "../../../../Components/Navbar/Navbar"
import Modal from "antd/es/modal/Modal"

import toast from "react-hot-toast"
import {
  changeStatusPurchaseOrder,
  getPurchaseOrder,
} from "../../../../Helpers/apiCalls/Purchases/purchaseOrderApi"
import {
  dateFormat,
  getType,
  numberFormat,
  refreshPage,
  toastStyle,
  TokenExpiry,
} from "../../../../Helpers/Utils/Common"
import PaymentTable from "../../../Sales/PaymentTable"
import Moment from "moment"
import "./../PurchaseOrders.css"
import POModal from "./POModal"
import noDataImg from "../../../../Assets/Images/no-data-img.png"
import Footer from "../../../../Components/Footer/Footer"
import AttachmentModal from "../../../../Components/AttachmentModal/AttachmentModal"

export default function ReviewPurchaseOrder() {
  const { state, id } = useParams()
  const poID = id
  let navigate = useNavigate()
  const [userType, setUserType] = useState(getType())
  const [isClicked, setIsClicked] = useState(false)

  const [inactive, setInactive] = useState(true)
  const [reviewPO, setReviewPO] = useState([])
  const [items, setItems] = useState([])
  const [paymentInfo, setPaymentInfo] = useState([])
  const [fileList, setFileList] = useState([])
  const [preview, setPreview] = useState(false)
  const [previewFile, setPreviewFile] = useState("")

  /* Attachments Modal */
  const [startAt, setStartAt] = useState(0)
  const [showAttachmentsModal, setShowAttachmentsModal] = useState(false)
  const handleShowAttachmentsModal = () => setShowAttachmentsModal(true)
  const handleCloseAttachmentsModal = () => setShowAttachmentsModal(false)

  async function fetchPO() {
    setReviewPO([])
    setItems([])

    const response = await getPurchaseOrder(poID)
    if (response.error) {
      TokenExpiry(response)
    } else {
      setReviewPO(response.response.data[0])
      setFileList(response.response.data[0].purchase_attachments)
      // setFileList(response.response.data[0].purchase_attachments);
      var itemDeets = response.response.data[0].purchase_items
      var purchasedItems = itemDeets.map((item) => {
        var info = {}

        info.id = item.id
        info.item_code = item.item_code
        info.ingredient_id = item.ingredient_id
        info.description = item.description
        info.item_name = item.item_name
        info.item_description = item.description
          ? item.item_id
            ? item.description + " - " + item.item_name
            : item.description
          : item.item_name
        info.qty = parseInt(item.qty)
        info.received_qty = item.received_qty ? parseInt(item.received_qty) : 0
        info.remaining_qty = item.remaining_qty
          ? parseInt(item.remaining_qty)
          : 0
        info.current_qty = item.inventory_qty ? parseInt(item.inventory_qty) : 0
        info.unit = item.unit
        info.price = `PHP ${numberFormat(item.price)}`
        info.discount_percentage = `PHP ${
          item.discount_percentage
            ? numberFormat(item.discount_percentage)
            : numberFormat(0)
        }`
        info.discount_amount = `PHP ${
          item.discount_amount
            ? numberFormat(item.discount_amount)
            : numberFormat(0)
        }`
        info.amount = `PHP ${numberFormat(item.amount)}`
        info.remarks = item.remarks || "-"
        info.last_received_date = item.last_received_date
        // ? formatDateSlash(item.last_received_date)
        // : "--/--/---";
        info.last_received_by = item.last_received_by
          ? item.last_received_by
          : "N/A"

        return info
      })
      setItems(purchasedItems)

      var payment = response.response.data[0].purchase_payment?.map((data) => {
        var info = data
        info.payment_date = Moment(data.payment_date).format("MMM DD, YYYY")
        // info.payment_mode = data.payment_mode;
        info.details =
          data.payment_mode === "check"
            ? data.payment_mode + " - " + data.check_no
            : data.payment_mode === "bank"
            ? data.payment_mode + " - " + data.reference_no
            : data.payment_mode === "others"
            ? data.type
              ? data.reference_no
                ? data.type + " - " + data.reference_no
                : data.type
              : data.reference_no
            : data.payment_mode
        info.amount = data.amount ? numberFormat(data.amount) : "0.00"
        info.amount_applied_to_invoice = data.amount_applied_to_invoice
          ? numberFormat(data.amount_applied_to_invoice)
          : "0.00"
        return info
      })
      setPaymentInfo(payment)
    }
  }

  const headersIncompleteOrComplete = [
    "Item Code",
    "Item Description",
    "Ordered Qty",
    "Received Qty",
    "Balance",
    // "Current Qty",
    "Unit",
    "Unit Price",
    // "Discount (%)",
    "Discount Amt",
    "Amount",
    "Remarks",
    "Latest Invoice Date",
    "Received by",
  ]
  const selectorsIncompleteOrComplete = [
    "item_code",
    "item_description",
    "qty",
    "received_qty",
    "remaining_qty",
    // "current_qty",
    "unit",
    "price",
    // "discount_percentage",
    "discount_amount",
    "amount",
    "remarks",
    "last_received_date",
    "last_received_by",
  ]

  const headers = [
    "Item No.",
    "Item Description",
    "Ordered Qty",
    "Current Qty",
    "Unit",
    "Unit Price",
    "Discount (%)",
    "Discount Amt",
    "Amount",
    "Remarks",
  ]
  const selectors = [
    "item_code",
    "item_description",
    "qty",
    "current_qty",
    "unit",
    "price",
    "discount_percentage",
    "discount_amount",
    "amount",
    "remarks",
  ]

  function handleClickImageThumbnail(index) {
    handleShowAttachmentsModal()
    setStartAt(index)
  }

  console.log(items)
  function renderTable() {
    return (
      <Table responsive>
        <thead>
          <tr>
            {reviewPO.order_status === "incomplete" ||
            reviewPO.order_status === "complete" ? (
              <>
                {headersIncompleteOrComplete.map((header) => {
                  return <th>{header}</th>
                })}
              </>
            ) : (
              <>
                {headers.map((header) => {
                  return <th>{header}</th>
                })}
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            return reviewPO.order_status === "incomplete" ||
              reviewPO.order_status === "complete" ? (
              <tr key={item.id}>
                {selectorsIncompleteOrComplete.map((selector) => {
                  return <td>{item[selector]}</td>
                })}
              </tr>
            ) : (
              <tr key={item.id}>
                {selectors.map((selector) => {
                  return <td>{item[selector]}</td>
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }
  /* Disapprove Modal */
  const [showDisapproveModal, setShowDisapproveModal] = useState(false)
  const handleShowDisapproveModal = () => setShowDisapproveModal(true)
  const handleCloseDisapproveModal = () => setShowDisapproveModal(false)

  /* Approve Modal */
  const [showApproveModal, setShowApproveModal] = useState(false)
  const handleShowApproveModal = () => setShowApproveModal(true)
  const handleCloseApproveModal = () => setShowApproveModal(false)

  /* Pending Modal */
  const [showPendingModal, setShowPendingModal] = useState(false)
  const handleShowPendingModal = () => setShowPendingModal(true)
  const handleClosePendingModal = () => setShowPendingModal(false)

  const [status, setStatus] = useState("")

  function approvePO(state) {
    if (state === "disapproved") {
      handleShowDisapproveModal()
    } else if (state === "approve") {
      handleShowApproveModal()
    } else {
      handleShowPendingModal()
    }

    setStatus(state)
  }

  function removeAttachmentItem(index) {
    const updatedFileList = [...fileList]
    updatedFileList.splice(index, 1)
    setFileList(updatedFileList)
  }

  async function submitApprovePO() {
    setIsClicked(true)
    const response = await changeStatusPurchaseOrder(poID, status)
    var text
    if (status === "pending") {
      text = "Returned to Pending"
    } else {
      text = status
    }
    if (response.response) {
      toast.success("Purchase Order " + text + " Successfully", {
        style: toastStyle(),
      })
      if (status === "approve") {
        setTimeout(
          () =>
            navigate("/purchaseorders/print/" + id, {
              state: {
                type: text.toLowerCase(),
                suppID: reviewPO.supplier_id,
              },
            }),
          1000
        )
      } else {
        setTimeout(() => navigate("/purchaseorders"), 1000)
      }
    } else if (response.error) {
      TokenExpiry(response)

      toast.error("Error Changing Status for Purchase Order No. " + id, {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    }
  }

  useEffect(() => {
    fetchPO()
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"PURCHASES"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={9}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              REVIEW PURCHASE ORDER{" "}
            </h1>
          </Col>
          <Col xs={12} lg={3}>
            <span className="PI-header2">PURCHASE ORDER NO. {id}</span>
          </Col>
        </Row>

        {/* content */}
        <div className="review-form mb-3 mt-2">
          <Row className="review-container py-3">
            <Row>
              <Col xs={6} lg={4}>
                <h3 className="review-label">Supplier Name</h3>
                <span className="review-data">
                  {reviewPO.supplier_trade_name
                    ? reviewPO.supplier_trade_name
                    : reviewPO.vendor_trade_name}
                </span>
              </Col>
              <Col xs={6} lg={4}>
                <h3 className="review-label">Purchase Date</h3>
                <span className="review-data">
                  {dateFormat(reviewPO.purchase_date)}
                </span>
              </Col>
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                <h3 className="review-label">Delivery Date</h3>
                <span className="review-data">
                  {dateFormat(reviewPO.delivery_date)}
                </span>
              </Col>
            </Row>
          </Row>
          <Row className="review-container py-3">
            <Row>
              <Col xs={12} lg={4}>
                <h3 className="review-label">BRANCH</h3>
                <span className="review-data">{reviewPO.branch_name}</span>
              </Col>
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                <h3 className="review-label">Contact Name</h3>
                <span className="review-data">{reviewPO.contact_name}</span>
              </Col>
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                <h3 className="review-label">CONTACT NO.</h3>
                <span className="review-data">{reviewPO.contact_no}</span>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={12} lg={4}>
                <h3 className="review-label">Requisitioner</h3>
                <span className="review-data">
                  {reviewPO.requisitioner_name}
                </span>
              </Col>
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                <h3 className="review-label">Forwarder</h3>
                <span className="review-data">{reviewPO.forwarder_name}</span>
              </Col>
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                <h3 className="review-label">Forwarder Contact No.</h3>
                <span className="review-data">
                  {reviewPO.forwarder_contact_person}
                </span>
              </Col>
            </Row>
          </Row>
          <Row className="review-container py-3">
            <Row className="">
              <Col xs={12} lg={4}>
                <span className="review-label">Delivery Address</span>
                <br></br>
                <span className="review-data">{reviewPO.delivery_address}</span>
              </Col>
              <Col xs={12} lg={4} className="mt-3 mt-lg-0">
                <span className="review-label">Remarks</span>
                <br></br>
                <span className="review-data">{reviewPO.remarks}</span>
              </Col>
            </Row>
          </Row>
          <div className="mt-4 d-flex flex-column">
            <span className="review-data mb-2">PURCHASED ITEMS</span>
            <div className="review-purchased-items purchased-items">
              {renderTable()}
            </div>
          </div>

          <div className=" ms-3 ps-3">
            <Row className="">
              <Col
                xs={6}
                lg={9}
                md={6}
                className="text-right bold review-label grand-label-review "
              >
                Subtotal
              </Col>
              <Col
                xs={6}
                lg={3}
                md={3}
                className="text-right review-label grand-label-review "
              >
                PHP{" "}
                {reviewPO.subtotal ? numberFormat(reviewPO.subtotal) : "0.00"}
              </Col>
            </Row>
            <Row className="">
              <Col
                xs={6}
                lg={9}
                md={6}
                className="text-right bold review-label grand-label-review "
              >
                Delivery/Service Fee
              </Col>
              <Col
                xs={6}
                lg={3}
                md={3}
                className="text-right review-label grand-label-review "
              >
                PHP{" "}
                {reviewPO.service_fee
                  ? numberFormat(reviewPO.service_fee)
                  : "0.00"}
              </Col>
            </Row>
            <Row className="">
              <Col
                xs={6}
                lg={9}
                md={6}
                className="text-right bold review-label grand-label-review "
              >
                Discount
              </Col>
              <Col
                xs={6}
                lg={3}
                md={3}
                className="text-right review-label grand-label-review "
              >
                PHP{" "}
                {reviewPO.discount ? numberFormat(reviewPO.discount) : "0.00"}
              </Col>
            </Row>
            <Row className="">
              <Col
                xs={6}
                lg={9}
                md={6}
                className="text-right bold review-label grand-label-review "
              >
                GRAND TOTAL
              </Col>
              <Col
                xs={6}
                lg={3}
                md={3}
                className="text-right review-label grand-label-review "
              >
                PHP{" "}
                {reviewPO.grand_total
                  ? numberFormat(reviewPO.grand_total)
                  : "0.00"}
              </Col>
            </Row>
          </div>

          <div className="mt-4 noPrint">
            <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
            <div className="d-flex flex-row gap-2 overflow-auto">
              {fileList &&
                fileList.map((attachment, index) => (
                  <div key={index} className="thumbnail-cont">
                    <img
                      src={attachment.file_url}
                      className="image-thumbnail"
                      alt=""
                      onClick={() => handleClickImageThumbnail(index)}
                    />
                  </div>
                ))}
              {!fileList ||
                (fileList.length === 0 && (
                  <div xs={1}>
                    <div className="no-data-cont d-flex justify-content-left preview-container">
                      <img
                        src={noDataImg}
                        alt="no data found"
                        className="img-preview"
                      />
                    </div>
                  </div>
                ))}
            </div>
          </div>

          {/* <div className="d-flex justify-content-end pt-5 pb-3">
            {state === "0" ? (
              <>
                <button
                  type="button"
                  className="button-secondary me-1"
                  onClick={() => navigate("/purchaseorders")}
                >
                  Close
                </button>
                {userType === "admin" ? (
                  <button
                    type="button"
                    className="button-warning me-1"
                    onClick={() => approvePO("disapproved")}
                  >
                    Disapprove
                  </button>
                ) : null}
                <button
                  type="button"
                  className="button-tertiary me-1"
                  onClick={() =>
                    navigate(
                      "/purchaseorders/edit/" +
                        id +
                        "/" +
                        "for_approval"
                    )
                  }
                >
                  Edit
                </button>
                {userType === "admin" ? (
                  <button
                    type="button"
                    className="button-primary"
                    onClick={() => approvePO("approve")}
                  >
                    Approve
                  </button>
                ) : null}
              </>
            ) : (
              <button
                type="button"
                className="button-secondary me-1"
                onClick={() => navigate("/purchaseorders")}
              >
                Close
              </button>
            )}
          </div> */}
        </div>
        <div className="d-flex justify-content-end pt-1 pb-3">
          {state === "0" ? (
            <>
              <button
                type="button"
                className="button-secondary me-1"
                onClick={() => navigate("/purchaseorders")}
              >
                Close
              </button>
              {userType === "admin" ? (
                <button
                  type="button"
                  className="button-warning me-1"
                  onClick={() => approvePO("disapproved")}
                >
                  Disapprove
                </button>
              ) : null}
              <button
                type="button"
                className="button-tertiary me-1"
                onClick={() =>
                  navigate("/purchaseorders/edit/" + id + "/" + "for_approval")
                }
              >
                Edit
              </button>
              {userType === "admin" ? (
                <button
                  type="button"
                  className="button-primary"
                  onClick={() => approvePO("approve")}
                >
                  Approve
                </button>
              ) : null}
            </>
          ) : (
            <button
              type="button"
              className="button-secondary me-1"
              onClick={() => navigate("/purchaseorders")}
            >
              Close
            </button>
          )}
        </div>
        {reviewPO.status === "sent" &&
          (reviewPO.order_status === "complete" ||
            reviewPO.order_status === "incomplete") && (
            <>
              <div className=" mt-3 mb-5 pb-3">
                <div className="tab-content mb-5">
                  <h5 className="PI-payment-info mt-3 ms-3">PAYMENT HISTORY</h5>
                  <PaymentTable
                    tableHeaders={[
                      "PAYMENT DATE",
                      "TYPE",
                      "DETAILS",
                      "PAYMENT AMOUNT",
                      "AMOUNT APPLIED TO INV",
                    ]}
                    headerSelector={[
                      "payment_date",
                      "payment_mode",
                      "details",
                      "amount",
                      "amount_applied_to_invoice",
                    ]}
                    tableData={paymentInfo}
                  />
                </div>
              </div>
              {/* <Container
                fluid
                className="PI-payment-info-wrapper mt-5 py-3 px-3 edit-form"
              >
                <h5 className="PI-payment-info">PAYMENT HISTORY</h5>
                <div className="justify-content-center">
                  <PaymentTable
                    tableHeaders={[
                      "PAYMENT DATE",
                      "TYPE",
                      "DETAILS",
                      "PAYMENT AMOUNT",
                      "AMOUNT APPLIED TO INV",
                    ]}
                    headerSelector={[
                      "payment_date",
                      "type",
                      "details",
                      "amount",
                      "amount_applied_to_invoice",
                    ]}
                    tableData={paymentInfo}
                  />
                </div>
              </Container> */}
            </>
          )}

        {/* Modals */}
        <POModal
          show={showApproveModal}
          hide={handleCloseApproveModal}
          type="approve"
          handler={submitApprovePO}
          isClicked={isClicked}
        />
        <POModal
          show={showDisapproveModal}
          hide={handleCloseDisapproveModal}
          type="disapprove"
          handler={submitApprovePO}
          isClicked={isClicked}
        />
        <POModal
          show={showPendingModal}
          hide={handleClosePendingModal}
          type="return"
          handler={submitApprovePO}
          isClicked={isClicked}
        />
        <Modal
          open={preview}
          title={""}
          footer={null}
          onCancel={() => setPreview(false)}
        >
          <img
            alt="example"
            style={{
              width: "100%",
            }}
            src={previewFile}
          />
        </Modal>
      </div>
      <Footer />
      <AttachmentModal
        show={showAttachmentsModal}
        images={fileList}
        onHide={() => handleCloseAttachmentsModal()}
        selected={startAt}
      />
    </div>
  )
}
